import { render, staticRenderFns } from "./StockViewWriteOff.vue?vue&type=template&id=545feb9c&scoped=true"
import script from "./StockViewWriteOff.vue?vue&type=script&lang=js"
export * from "./StockViewWriteOff.vue?vue&type=script&lang=js"
import style0 from "./StockViewWriteOff.vue?vue&type=style&index=0&id=545feb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545feb9c",
  null
  
)

export default component.exports